import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import Header from "../component/header";
import Footer from "../component/Footer";
const QUEST_FEATURED_GALLERY_ID = "6a1f2a3cd388b57911134962";

function GalleryCategory() {
  const { category = "quests" } = useParams();
  const [redirectTarget, setRedirectTarget] = useState("");

  useEffect(() => {
    let isMounted = true;

    async function resolveTarget() {
      try {
        const response = await fetch("/api/gallery/categories");
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          throw new Error("Unable to resolve gallery destination.");
        }

        const activeCategory = result.data.find((item) => item.key === category);
        const targetId =
          category === "quests"
            ? QUEST_FEATURED_GALLERY_ID
            : activeCategory?.featuredGalleryId;

        if (isMounted && targetId) {
          setRedirectTarget(`/gallery/${category}/${targetId}`);
        } else if (isMounted) {
          setRedirectTarget("/gallery");
        }
      } catch (err) {
        if (isMounted) {
          setRedirectTarget("/gallery");
        }
      }
    }

    resolveTarget();
    return () => {
      isMounted = false;
    };
  }, [category]);

  if (redirectTarget) {
    return <Navigate to={redirectTarget} replace />;
  }

  return (
    <div className="min-h-screen bg-[#f7f8f8] text-left">
      <Header />
      <main className="px-4 py-20 text-center">
        <p className="font-outfit text-sm text-[#687475]">Redirecting to gallery...</p>
      </main>
      <Footer />
    </div>
  );
}

export default GalleryCategory;
